<template>
  <v-container>
    <v-card>
      <v-toolbar color="grey lighten-2">
        <v-toolbar-title>Expense Form</v-toolbar-title>
        <v-spacer></v-spacer>
        <AccounCreate
          :Display="LoadAccounts"
          :AccountType="AccountType"
        ></AccounCreate>
      </v-toolbar>
      <v-card-title primary-title>
        Cash:
        <v-spacer></v-spacer>
        {{ AvBalance.toLocaleString() }} ksh
      </v-card-title>
      <v-card-text>
        <!-- {{ expense }} -->
        <v-form ref="ExpenseForm">
          <v-select
            :rules="[v => !!v || 'Cash Account is required']"
            v-model="expense.Account"
            :items="cashAccounts"
            @change="OnAccoutSelect"
            item-value="_id"
            item-text="AccountName"
            label="Cash Accunt"
            outlined
            :loading="loading"
            :disabled="loading"
          ></v-select>
          <v-select
            :rules="[v => !!v || 'Expense Type is required']"
            v-model="expense.type"
            :items="Expenses"
            label="Expense Type"
            outlined
            return-object
          ></v-select>
          <base-date
            v-model="expense.date"
            outlined
            :rules="[v => !!v || 'Expense Date is required']"
            label="Withdrow Date"
            prepend-inner-icon="mdi-calendar-month-outline"
          />
          <!-- <v-text-field
            prepend-inner-icon="mdi-calendar-month-outline"
            v-model="expense.date"
            outlined
            :rules="[v => !!v || 'Expense Date is required']"
            required
            name="withdrowFild"
            label="Withdrow Date"
            type="date"
          ></v-text-field> -->
          <v-row justify="center">
            <v-col cols="8" md="8">
              <v-text-field
                :rules="[v => !!v || 'Amount is required']"
                name="ExpenseAmount"
                label="Expense Amount"
                id="ExpenseAmountid"
                outlined
                v-model.number="expense.Amount"
              ></v-text-field>
            </v-col>
            <v-col cols="8" md="4">
              <p
                v-if="expense.Amount"
                class="font-weight-black text-center black--text mt-md-5"
              >
                {{ expense.Amount.toLocaleString() }} ksh
              </p>
            </v-col>

            <v-col cols="8">
              <v-btn :loading="clicked" @click="OnExpense" color="success" block
                >Save</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import AccounCreate from "@/components/NewAccount";
import axios from "axios";
export default {
  components: { AccounCreate },
  data() {
    return {
      AccountType: "Expenses",
      clicked: false,
      loading: false,
      errMsg: "",
      Expenses: [],
      cashAccounts: [],
      AvBalance: 0,
      expense: {
        type: "",
        Amount: null,
        Account: "",
        date: "",
      },
    };
  },
  methods: {
    OnExpense() {
      if (this.$refs.ExpenseForm.validate()) {
        // console.log(this.expense);
        this.clicked = true;
        this.expense.AmountType = "KES";
        // this.expense.date = this.Current().date;
        this.expense.time = this.Current().time;
        this.$store
          .dispatch("INSERT_ONLY", {
            url: "/qarash/Expense",
            data: this.expense,
          })
          .then(() => {
            // console.log(val);
            this.clicked = false;
            this.$refs.ExpenseForm.reset();
            this.LoadAccounts();
          })
          .catch(() => {
            this.clicked = false;
            // console.log(error);
          });
      }
    },
    AmountCheking(v) {
      if (v > this.AvBalance) return "Balance is not Enough";
      else if (Number(v) == 0 || isNaN(Number(v))) return "invalid Amount";
      else return true;
    },
    GetReg(name) {
      return this.$store.dispatch("FIND_BY_VALUE_ONLY", {
        url: "/qarash/Accounts",
        ID: name,
      });
    },
    ShowBittyCash(AccName) {
      return this.$store.dispatch("INSERT_ONLY", {
        url: "/qarash/totalcash",
        data: { Account: AccName, cashType: "KES" },
        // data: { Account: "Main Cash", cashType: "KES" },
      });
    },
    OnAccoutSelect(val) {
      // console.log(this.expense.Account);
      this.loading = true;
      this.AvBalance = 0;
      let { AccountName } = this.cashAccounts.find(({ _id }) => val == _id);
      this.ShowBittyCash(AccountName)
        .then(result => {
          this.loading = false;
          // console.log(result);
          if (result.data.length > 0) this.AvBalance = result.data[0].Amount;
          // else this.AvBalance = 0;
        })
        .catch(err => {
          this.loading = false;
          this.errMsg = err.respnse && err.respnse.data;
        });
    },
    LoadAccounts() {
      axios
        .all([
          this.GetReg(this.AccountType),
          this.GetReg("Cash"),
          // this.ShowBittyCash(),
        ])
        .then(result => {
          // console.log(result[2]);
          //Availble Balance of Bitty Cash
          // if (result[2].data.length > 0)
          //   this.AvBalance = result[2].data[0].Amount;
          // else this.AvBalance = 0;
          //withdraw Account
          // this.expense.Account = result[1].data[0]._id;
          // console.log(result[1]);
          this.cashAccounts = result[1].data.filter(
            acc =>
              acc.AccountName == "Main Cash" ||
              acc.AccountName == "M-PESA" ||
              acc.AccountName == "Bitty Cash"
          );
          // this.cashAccounts = result[1].data;

          //All Expenses Account
          result[0].data.forEach(element => {
            this.Expenses.push({
              text: element.AccountName,
              value: element._id,
            });
          });
        });
    },
  },

  created() {
    this.LoadAccounts();
  },
};
</script>
